import React from 'react';

import SideBarContainer from '../sideBar/SideBarContainer';

import headerTitleStyles from './headerTitle.module.css';

interface HeaderTitleProps {
 titlePage: string;
 titleRole: string;
};

const headerTitle: React.FunctionComponent<HeaderTitleProps> = props => {

  const header: JSX.Element = 
    <header className={ headerTitleStyles.header }>
      <div className={ headerTitleStyles.companyName }>TryPod</div>
      <div>{ props.titleRole } - { props.titlePage }</div>
    </header>;

  return (
    <div className={ headerTitleStyles.headerWrapper }>
      <div className={ headerTitleStyles.titleNavWrapper }>
        <SideBarContainer />
        { props.titlePage && header }
        <div className={ `${ headerTitleStyles.titleNavMiddle }` } />
      </div>
      { props.children }
    </div>
  );
};

export default headerTitle;